export const getCookie = name => {
  const cookies = document.cookie.split(';').map(v => v.trim());
  const cookie = cookies.find(v => v.startsWith(`${name}=`));

  // + 1 because we cut off the equal sign (=)
  return cookie?.substring(name.length + 1);
};
